import { defineMessages } from 'react-intl';

export const duplicateSnippetModalMessages: {
	titleDuplicate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	duplicateButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	duplicateSuccessFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	duplicateErrorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	duplicateErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	titleDuplicate: {
		id: 'snippets.snippetEditorModal.titleDuplicate',
		defaultMessage: 'Create duplicate of {snippetName}',
		description: 'Title for the duplicate block template modal',
	},
	duplicateButton: {
		id: 'snippets.snippetEditorModal.duplicateButton',
		defaultMessage: 'Duplicate',
		description: 'Duplicate button text for duplicate mode',
	},
	duplicateSuccessFlagTitle: {
		id: 'snippets.snippetEditorModal.duplicateSuccessFlagTitle',
		// oxlint-disable-next-line eslint-core/no-restricted-syntax
		defaultMessage: 'Template "{snippetName}" duplicated',
		description: 'Success flag title shown when a block template has been duplicated',
	},
	duplicateErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.duplicateErrorFlagTitle',
		defaultMessage: 'Could not duplicate the template',
		description: 'Error flag title shown when a block template duplication fails',
	},
	duplicateErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.duplicateErrorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Error flag description shown when a block template duplication fails',
	},
});
